import React from "react";
import { LegacyCard, Stack, Text } from "@shopify/polaris";
import { chair } from "../../../../../../../../../../assets/index.js";
import AddItemsButtons from "../AddItemsButtons.js";

const PreviewSelectSection = ({ handleAddProducts, handleAddCollections, initialSelectionIds }) => {
  return (
    <LegacyCard>
      <LegacyCard.Section>
        <Stack alignment={"center"} vertical>
          <img
            alt="createCatalogImage"
            width="110px"
            height="150px"
            style={{
              objectFit: "cover",
              objectPosition: "center"
            }}
            src={chair}
          />
          <Text variant={"bodySm"} as={"p"}>Which product do you want to target?</Text>
          <p>You can import your product or collection.</p>
          <AddItemsButtons
            handleAddProducts={handleAddProducts}
            handleAddCollections={handleAddCollections}
            initialSelectionIds={initialSelectionIds}
          />
        </Stack>
      </LegacyCard.Section>
    </LegacyCard>
  );
};

export default PreviewSelectSection;